<template>
    <div>
        <div class="background-page"
            :class="{ 'active': isBackgroundPage, 'user-menu': isSidebarActive && !tablet, 'modal-active': isModalRegionActive }"
            @click.prevent="backroundPageFun(false)" @contextmenu.prevent></div>
        <header class="header-inner header-inner__wrap" ref="headerInner" :class="{
            'no_blur': blurStub,
            'full-size': fullWidth,
            'header-inner__products': productsHeader,
            'is--active': isSubMenuMobileActive && mobile,
        }">
            <div class="header-inner__fixed-wrap">
                <div class="header-inner__container-top container container-xl">
                    <div class="header-inner__search--mob" v-if="mobile">
                        <div class="header-inner__search-button" :class="{ active: isSubMenuMobileActive }" @click="subMenuMobileFun">
                            <svg v-if="isSubMenuMobileActive" class="active" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3838 11.7002L4.33474 5.65117C3.88842 5.20486 3.88842 4.48124 4.33474 4.03493C4.78105 3.58862 5.50467 3.58862 5.95098 4.03493L12 10.084L18.049 4.03493C18.4953 3.58862 19.219 3.58862 19.6653 4.03493C20.1116 4.48124 20.1116 5.20486 19.6653 5.65117L13.6162 11.7002L19.6653 17.7492C20.1116 18.1955 20.1116 18.9191 19.6653 19.3655C19.219 19.8118 18.4953 19.8118 18.049 19.3655L12 13.3164L5.95098 19.3655C5.50467 19.8118 4.78105 19.8118 4.33474 19.3655C3.88842 18.9191 3.88842 18.1955 4.33474 17.7492L10.3838 11.7002Z"
                                    fill="#9BA1AB"/>
                            </svg>
                            <svg v-else class="default" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                                <path d="M20.8928 21.0485L21.6077 20.3492L21.607 20.3485L20.8928 21.0485ZM15.1778 15.2172L14.4765 14.5044L13.7651 15.2044L14.4636 15.9171L15.1778 15.2172ZM20.8821 21.5821L21.5672 22.3105L21.5686 22.3092L20.8821 21.5821ZM20.3382 21.5715L21.0544 20.8736L21.0524 20.8716L20.3382 21.5715ZM14.6094 15.7259L15.3236 15.0259L14.6855 14.3748L13.9783 14.9501L14.6094 15.7259ZM21.607 20.3485L15.892 14.5172L14.4636 15.9171L20.1786 21.7484L21.607 20.3485ZM21.5686 22.3092C22.1282 21.7808 22.1457 20.8992 21.6077 20.3492L20.178 21.7478C19.9338 21.4981 19.9421 21.0943 20.1956 20.855L21.5686 22.3092ZM20.6155 22.6874C20.9551 22.6874 21.2991 22.5627 21.5672 22.3105L20.1969 20.8537C20.3158 20.7418 20.4683 20.6874 20.6155 20.6874V22.6874ZM19.622 22.2694C19.8972 22.5518 20.2617 22.6874 20.6155 22.6874V20.6874C20.7671 20.6874 20.93 20.746 21.0544 20.8736L19.622 22.2694ZM13.8952 16.4258L19.624 22.2715L21.0524 20.8716L15.3236 15.0259L13.8952 16.4258ZM9.46169 18.5493C11.6541 18.5493 13.6696 17.7796 15.2405 16.5016L13.9783 14.9501C12.7522 15.9476 11.1793 16.5493 9.46169 16.5493V18.5493ZM0.384766 9.62472C0.384766 14.5647 4.4736 18.5493 9.46169 18.5493V16.5493C5.54208 16.5493 2.38477 13.4244 2.38477 9.62472H0.384766ZM9.46169 0.700195C4.4736 0.700195 0.384766 4.68476 0.384766 9.62472H2.38477C2.38477 5.82507 5.54208 2.7002 9.46169 2.7002V0.700195ZM18.5386 9.62472C18.5386 4.68476 14.4498 0.700195 9.46169 0.700195V2.7002C13.3813 2.7002 16.5386 5.82507 16.5386 9.62472H18.5386ZM15.8792 15.93C17.5172 14.3183 18.5386 12.0883 18.5386 9.62472H16.5386C16.5386 11.5227 15.7539 13.2474 14.4765 14.5044L15.8792 15.93ZM9.46169 15.7945C5.96632 15.7945 3.154 13.0082 3.154 9.62472H1.154C1.154 14.1485 4.89783 17.7945 9.46169 17.7945V15.7945ZM15.7694 9.62472C15.7694 13.0081 12.9567 15.7945 9.46169 15.7945V17.7945C14.0251 17.7945 17.7694 14.1485 17.7694 9.62472H15.7694ZM9.46169 3.45491C12.9571 3.45491 15.7694 6.2413 15.7694 9.62472H17.7694C17.7694 5.10098 14.0255 1.45491 9.46169 1.45491V3.45491ZM3.154 9.62472C3.154 6.2413 5.96632 3.45491 9.46169 3.45491V1.45491C4.89783 1.45491 1.154 5.10098 1.154 9.62472H3.154Z"
                                    fill="#9BA1AB"/>
                            </svg>
                        </div>
                    </div>
                    <div class="header-inner__col header-inner__col--left">
                        <a class="header-inner__header-logo" :href="'/' + language">
                            <picture>
                                <source srcset="/img/icons/logo-small.svg" media="(max-width: 600px)">
                                <img class="img-responsive" src="/img/icons/logo-big.svg" alt="Логотип сайта">
                            </picture>
                        </a>
                    </div>
                    <div class="header-inner__col header-inner__col--center" v-if="!mobile">
                        <HeaderCatalog :mobile="mobile" 
                            :isCatalogActive="isCatalogActive"
                            :categories="categories" 
                            @active-catalog="catalogFun" />
                        <HeaderSearch :mobile="mobile"
                            :isGuest="isGuest"
                            :isFilterCatalogActive="isFilterCatalogActive"
                            :categories="categories"
                            :language="language"
                            :btnPreloaderSubmitProp="btnPreloaderSubmit"
                            :isSearchResultVisibleProp="isSearchResultVisible"
                            @toggle-filter-catalog="filterCatalogFun"
                            @search-active="searchResultActive" />

                    </div>
                    <NavbarRight ref="NavbarRightRef" :isGuest="isGuest" :mobile="mobile" :tablet="tablet"
                        :avatar="avatar" :language="language" :cartData="cartData" :countChat="countChat"
                        :isUserSeller="isUserSeller" :cartCount="cartCount"
                        :isSidebarActive="isSidebarActive" :notificationData="notificationData"
                        :isMiniCartActive="isMiniCartActive" :isFetchHeaderReady="isFetchHeaderReady"
                        :isNotificationActive="isNotificationActive" :enabledChatIcon="enabledChatIcon"
                        :isShowRegionModal="isShowRegionModal" :userNotificationCount="userNotificationCount"
                        :isMiniChatOpen="isMiniChatOpen" :isEnableMiniChat="isEnableMiniChat"
                        @is-active-chat="enableMiniChatFun" @count-chat="countChat = $event"
                        @enabled-chat-icon="enabledChatIcon = true" @toggle-mini-chat="miniChatFun"
                        @modal-region-show="isModalRegionActive = true" @toggle-mini-cart="miniCartFun"
                        @toggle-notification="notificationFun" @count-notification="userNotificationCount = $event"
                        @toggle-sidebar="sidebarFun" />
                </div>
                <div class="header-search__form-wrap-mob" v-if="mobile && isFirstLoad">
                    <SlideUpDown :active="isHeaderInnerMobileActive" :duration="400">
                        <div class="header-search__form-wrap-mob-item">
                            <HeaderCatalog :mobile="true"
                                :categories="categories"
                                :isCatalogActive="isCatalogActive"
                                @active-catalog="catalogFun" />
                            <HeaderSearch :isGuest="isGuest" :mobile="true" :language="language"
                                :isSearchResultVisibleProp="isSearchResultVisible"
                                :categories="categories"
                                :isFilterCatalogActive="isFilterCatalogActive"
                                :btnPreloaderSubmitProp="btnPreloaderSubmit"
                                @toggle-filter-catalog="filterCatalogFun"
                                @search-active="searchResultActive" />
                        </div>
                    </SlideUpDown>
                </div>
            </div>
        </header>
        <transition name="sidebar-info">
            <Sidebar ref="SidebarRef" v-if="!isGuest && isFetchHeaderReady && isFirstLoad && isSidebarActive"
                :mobile="mobile" :countChat="countChat" :tablet="tablet" :avatar="avatar"
                :sidebarData="sidebarData" :language="language"
                :isSidebarActive="isSidebarActive" :userNotificationCount="userNotificationCount"
                :isNotificationActive="isNotificationActive" :cartCount="cartCount"
                :cartCost="cartCost" :enabledChatIcon="enabledChatIcon"
                @toggle-sidebar="sidebarFun" @toggle-notification="notificationFun" />
        </transition>
        <!-- <ModalAddToCart v-if="isFetchHeaderReady && isFirstLoad" :mobile="mobile" :language="language"
            :cartCostProp="cartCost" :isShowRegionModal="isShowRegionModal" :discountCartCostProp="discountCartCost"
            :cartDataProp="cartData" :isUserSeller="isUserSeller" :isModalCartActiveProp="isModalCartActive"
            :isModalRegionActive="isModalRegionActive"
            @modal-region-show="isModalRegionActive = true" @close-modal-cart="isModalCartActive = false" /> -->

        <ModalAuthorization v-if="isGuest && isFetchHeaderReady" @close-auth-modal="showAuthModal = false"
            :authData="auth" :showAuthModal="showAuthModal" :ifActivePayment="ifActivePayment"
            :isDifmark="false"
            :mobile="mobile" />

    </div>
</template>

<script>
import NavbarRight from './parts/NavbarRight.vue';
import HeaderCatalog from './parts/HeaderCatalog.vue';
import HeaderSearch from './parts/HeaderSearch.vue';
import Sidebar from './parts/Sidebar.vue';
import Notifications from './parts/Notifications.vue';
import ModalAddToCart from './parts/ModalAddToCart.vue';
import ModalRegion from './parts/ModalRegion.vue';
import ModalAuthorization from '/webpack-assets/vue/templates/site/authorization/ModalAuthorization.vue';
import SlideUpDown from 'vue-slide-up-down';
import axios from '/webpack-assets/vue/config/axios-config';
import { debounce, throttle } from '/webpack-assets/vue/utils/common.js';

export default {
    components: {
        NavbarRight,
        HeaderCatalog,
        HeaderSearch,
        Sidebar,
        Notifications,
        ModalAddToCart,
        ModalRegion,
        ModalAuthorization,
        SlideUpDown,
    },
    data() {
        return {
            language: window.common.language.code2 || 'en',
            // promo: window.header.promo ?? null,
            avatar: window.common?.user?.avatar || null,
            blurStub: window?.header.blurStub,
            fullWidth: window?.header.fullWidth,
            productsHeader: window?.header.productsHeader,
            isGuest: window.common.is_guest,
            isUserSeller: window.common?.user?.is_seller || false,
            categories: window.header.menu,
            isEnableMiniChat: window?.settings?.enable_mini_chat ?? true,
            userNotificationCount: window?.header?.inbox?.count_unread || 0,
            countChat: window?.header?.chat?.count_unread_conversations || 0,
            auth: [],
            sidebarData: null,
            notificationData: null,
            cartData: null,
            cartCount: window?.header?.cart?.count || 0,
            cartCost: null,
            isShowRegionModal: false,
            regionMismatchProducts: [],
            discountCartCost: null,
            isFetchHeaderReady: false,
            isHeaderSticky: false,
            previousScrollHeader: 0,
            previousScrollSubHeader: 0,
            offsetHeader: null,
            offsetSubHeader: null,
            subHeaderElement: null,
            launcher: null,
            btnPreloaderSubmit: false,
            isBackgroundPage: false,
            isCatalogActive: false,
            isFilterCatalogActive: false,
            isNotificationActive: false,
            isMiniCartActive: false,
            isModalCartActive: false,
            isModalRegionActive: false,
            isHeaderInnerMobileActive: false,
            isSubMenuMobileActive: false,
            isSearchResultVisible: false,
            isSidebarActive: false,
            isMiniChatActive: true,
            isMiniChatOpen: false,
            enabledChatIcon: false,
            isFirstLoad: false,
            showAuthModal: false,
            ifActivePayment: false,
            mobile: false,
            tablet: false,
        };
    },
    mounted() {
        this.checkMobile();
        this.checkTablet();

        this.launcher = document.querySelector("#launcher");
        this.fetchHeaderData()
        setTimeout(() => {
            this.isFirstLoad = true;
        }, 1200);
        window.updateMiniCarts = this.updateMiniCart;

        if (!document.getElementById('auth-modal-wyrel-bg')) {
            const s = document.createElement('style');
            s.id = 'auth-modal-wyrel-bg';
            s.textContent = '.modal-content.authorization-modal.wyrel-modal { background-color: #fff !important; background: #fff !important; border-radius: 24px !important; max-width: 500px !important; overflow: visible !important; } @media (max-width: 767px) { .modal-content.authorization-modal.wyrel-modal { border-radius: 24px 24px 0 0 !important; max-width: 100% !important; width: 100% !important; } }';
            document.head.appendChild(s);
        }

        this._handleShowAuthModal = () => {
            if (this.isFetchHeaderReady && this.isFirstLoad) {
                const { payment } = event.detail || {};
                this.showAuthModal = true;

                if (payment) this.ifActivePayment = payment;
            } else {
                this.showAuthModal = false;
            }
        };
        this._handleHideAuthModal = () => {
            this.showAuthModal = false;
            this.ifActivePayment = false;
        };
        window.addEventListener('showAuthModal', this._handleShowAuthModal);
        window.addEventListener('hideAuthModal', this._handleHideAuthModal);
    },
    beforeDestroy() {
        window.removeEventListener('showAuthModal', this._handleShowAuthModal);
        window.removeEventListener('hideAuthModal', this._handleHideAuthModal);
    },
    computed: {
        flattenedList() {
            const categoriesArray = Object.values(this.categories.list);

            return categoriesArray.reduce((acc, category) => {

                const itemsArray = Object.values(category.items);
                return acc.concat(itemsArray);
            }, []);
        }
    },
    methods: {
        checkMobile() {
            this.mobile = window.innerWidth < 768;
        },
        checkTablet() {
            this.tablet = window.innerWidth < 992;
        },
        backroundPageFun(val) {
            this.isSearchResultVisible = val;
            this.isBackgroundPage = val;

            if (!this.isBackgroundPage) {
                this.btnPreloaderSubmit = false;
                this.isSubMenuMobileActive = false;
                this.isHeaderInnerMobileActive = false;
                this.handleCloseSidebarSearch()
                this.handleCloseNotifyCartCatalog()

                this.handleClasses(false)
            }
        },
        subMenuMobileFun() {
            this.isSubMenuMobileActive = !this.isSubMenuMobileActive;
            this.handleCloseNotifyCartCatalog()
            this.handleCloseSidebarSearch()

            this.isBackgroundPage = this.isSubMenuMobileActive;
            this.isHeaderInnerMobileActive = this.isSubMenuMobileActive;

            this.handleClasses(this.isSubMenuMobileActive)
        },
        handleClasses(ifAdd) {
            const action = ifAdd ? 'add' : 'remove';

            this.isMiniChatActive = !ifAdd;
            if (this.launcher) {
                document.querySelector("#launcher").classList[action]("is--hidden-mobile");
            }
            document.querySelector("body").classList[action]("noscroll");
        },
        handleCloseNotifyCartCatalog() {
            this.isMiniChatOpen = false;
            this.isNotificationActive = false;
            this.isMiniCartActive = false;
            this.isCatalogActive = false;
        },
        handleCloseSidebarSearch() {
            this.isSearchResultVisible = false;
            this.isSidebarActive = false;
            this.isFilterCatalogActive = false;
        },
        searchResultActive(val) {
            this.isSearchResultVisible = val;
            this.handleCloseNotifyCartCatalog()
            this.isFilterCatalogActive = false;
            this.isSidebarActive = false;
            this.isMiniChatActive = !val;
            if (!this.mobile) {
                this.isBackgroundPage = val;
            }
        },
        sidebarFun(val) {
            this.isSidebarActive = !this.isSidebarActive;
            this.isBackgroundPage = this.isSidebarActive;
            this.handleCloseNotifyCartCatalog()
            this.isSubMenuMobileActive = false;
            this.isHeaderInnerMobileActive = false;
            this.isSearchResultVisible = false;
            this.isFilterCatalogActive = false;
            this.isMiniChatActive = !this.isSidebarActive;
            if (!this.mobile) {
                this.handleClasses(this.isSidebarActive)
            }
        },
        filterCatalogFun() {
            this.isMiniChatOpen = false;
            if (this.isFilterCatalogActive) {
                this.handleCloseSidebarSearch()
                this.handleCloseNotifyCartCatalog()
            } else {
                this.isFilterCatalogActive = true;
            }
            this.isCatalogActive = false;
            this.isSidebarActive = false;
            this.isMiniChatActive = !this.isFilterCatalogActive;
            if (this.mobile) {
                this.isBackgroundPage = true;
                this.handleClasses(true)
            } else {
                this.isBackgroundPage = this.isFilterCatalogActive;
            }
        },
        catalogFun() {
            this.isMiniChatOpen = false;
            this.isCatalogActive = !this.isCatalogActive;
            this.isNotificationActive = false;
            this.isFilterCatalogActive = false;
            this.handleCloseSidebarSearch()
            this.isMiniCartActive = false;
            this.isMiniChatActive = !this.isCatalogActive;
            if (this.mobile) {
                this.isBackgroundPage = true;
                this.handleClasses(true)
            } else {
                this.isBackgroundPage = this.isCatalogActive;
            }
        },
        enableMiniChatFun() {
            this.isMiniChatOpen = true;
            this.isEnableMiniChat = true;
        },
        miniChatFun() {
            const isOpen = !this.isMiniChatOpen;
            this.handleCloseNotifyCartCatalog();
            this.handleCloseSidebarSearch();
            this.isBackgroundPage = false;
            this.isMiniChatOpen = isOpen;
        },
        miniCartFun() {
            this.isMiniChatOpen = false;
            if (this.cartCount !== 0) {
                this.isMiniCartActive = !this.isMiniCartActive;
                this.isBackgroundPage = this.isMiniCartActive;
                this.isFilterCatalogActive = false;
                this.isNotificationActive = false;
                this.handleCloseSidebarSearch()
                this.handleClasses(this.isMiniCartActive)
            } else {
                this.isMiniCartActive = false;
                this.isBackgroundPage = false;
                this.isNotificationActive = false;
                this.handleCloseSidebarSearch()

                this.handleClasses(false)
            }
        },
        notificationFun() {
            this.isMiniChatOpen = false;
            if (this.mobile && this.notificationData 
                && this.notificationData?.shown_main_count == 0 
                && this.notificationData?.shown_inbox_count == 0) return;
            this.isNotificationActive = !this.isNotificationActive;
            if (!this.tablet) {
                this.isBackgroundPage = this.isNotificationActive;
            } else {
                this.isBackgroundPage = false;
            }
            this.isSubMenuMobileActive = false;
            this.isCatalogActive = false;
            this.isMiniCartActive = false;
            this.handleCloseSidebarSearch()
            this.handleClasses(this.isNotificationActive)
        },
        fetchHeaderData() {
            axios.get('/' + this.language + '/site-api/header')
                .then(response => {
                    this.sidebarData = response.data.sidebar;
                    this.notificationData = response.data.inbox;
                    this.cartData = response.data.cart;
                    this.cartCost = response.data.cart.total;
                    this.discountCartCost = response.data.cart?.discount_cost;
                    this.isFetchHeaderReady = true;
                    //this.productsRegionFun(response.data.cart.items);
                    if (this.isUserSeller) {
                        this.discountCartCost = response.data.cart.cost;
                    }
                    if (response.data.auth && Object.keys(response.data.auth).length > 0) {
                        this.auth = response.data.auth;
                        if (!this.auth.language) {
                            this.auth.language = this.language;
                        }
                        if (!this.auth.company_name) {
                            this.auth.company_name = 'Wyrel';
                        }
                        if (this.auth.social_urls) {
                            const allowedSocials = ['facebook', 'google', 'twitch', 'microsoft', 'yandex'];
                            this.auth.social_urls = this.auth.social_urls.filter(s => allowedSocials.includes(s.id));
                        }
                    }
                    if (this.auth && Object.keys(this.auth).length > 0) {
                        if (this.isGuest) {
                            const url = new URL(window.location.href);
                            const params = url.searchParams;
                            if (params.get('auth') === 'modal') {
                                this.$nextTick(() => {
                                    this.showAuthModal = true;
                                });
                                params.delete('auth');
                                window.history.replaceState({}, '', `${url.pathname}${params.toString() ? '?' + params.toString() : ''}${url.hash}`);
                            }
                        }
                    }
                })
                .catch(error => {
                    console.error('Error response:', error);
                });
        },
        updateMiniCart(count, itemId, ifOpenModalCart = true, discount = null) {
            let data = {};
            const params = new URLSearchParams(window.location.search);
            const couponParam = discount || params.get('coupon');
            if (count != null && itemId != null) {
                data = {
                    count: count,
                    itemId: itemId,
                };
            }

            if(couponParam) {
                data.coupon = couponParam;
            }

            if (count === 0) {
                const offersContainer = document.querySelector('.offers');
                if (offersContainer) {
                    const itemElement = offersContainer.querySelector('#' + CSS.escape(itemId));
                    itemElement?.classList.remove('card-added');
                }
                window.dispatchEvent(new CustomEvent('updateIsAddedToCart', { detail: { itemId: itemId } }));
            }

            axios.get('/cart/ajax-update', { params: data })
                .then((response) => {
                    this.cartData = response.data;
                    this.cartCount = response.data.count;
                    this.cartCost = response.data.total;
                    // this.discountCartCost = response.data?.discount_cost;
                    // this.productsRegionFun(response.data.items);
                    // this.isModalCartActive = ifOpenModalCart;

                    if (this.cartCount === 0) {
                        this.miniCartFun(false)
                        this.isModalCartActive = false;
                    }

                    // $(".cart-button .cart-cost").html($(response.data).find(".cart-price").html());
                    // $('.cart-button').addClass('js-cart-button');
                    $("#cardModal .popup-cart-wrap").html(response.data.html);
                    if (response.data.count == 0) {
                        window.dispatchEvent(new CustomEvent('updateIsAddedToCart', { detail: { itemId: itemId } }));
                        // $('.js-cart-button').removeClass('js-cart-button');
                        // $(".cart-button").removeClass("active");
                        window.showOldModalCart(false)
                        //$('.background-page').removeClass('active');
                    } else if (ifOpenModalCart) {
                        window.showOldModalCart(true)
                    }
                })
                .catch((error) => {
                    console.error('Error updating mini cart:', error);
                });
        },
        // productsRegionFun(data) {
        //     this.regionMismatchProducts = data.filter(product =>
        //         !(product.region?.has_country || product.region?.region_name_tech === 'GLOBAL')
        //     );
        //     this.isShowRegionModal = this.regionMismatchProducts.length > 0 ? true : false;
        // },
    }
};
</script>

<style lang="scss">
@use "../header/style/header.scss";
.fade-info-enter-active,
.fade-info-leave-active {
    transition: opacity 0.4s ease;
}

.fade-info-enter-from,
.fade-info-leave-to {
    opacity: 0;
}

.fade-info-enter-to,
.fade-info-leave-from {
    opacity: 1;
}

.sidebar-info-enter-active,
.sidebar-info-leave-active {
    transition: transform 0.5s ease;
}

.sidebar-info-enter-from,
.sidebar-info-leave-to {
    transform: translate(120%, 0);
}

.sidebar-info-enter-to,
.sidebar-info-leave-from {
    transform: translate(0);
}

#headerVue {
    @media only screen and (max-width: 767px) {
        .background-page.active {
            backdrop-filter: blur(5px);
            background-color: rgba(17, 21, 26, 0.5);
        }
    }
}
</style>